(function () {
  "use strict";

  FeaturesResolver.$inject = ['$q', 'Validation', 'refreshSession', 'Auth', '$location'];
  angular
    .module('trainerWebApp.resources')
    .factory('FeaturesResolver', FeaturesResolver);

  function FeaturesResolver($q, Validation, refreshSession, Auth, $location) {

    return function () {


      var authorize = function () {
          return Auth.getRolePromise();
        },

        refresh = function () {
          return refreshSession.resource().$promise;
        };

      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      $q.all([authorize(), refresh()])
        .then(function (result) {
          deferred.resolve();
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };
  }

})();
